import { useEffect, useRef, type ReactNode } from 'react';
import { Modal } from '@engie-group/fluid-design-system';
import { NJButton } from '@engie-group/fluid-design-system-react';
import CenterModal from '@shared/modal/CenterModal';

export function ConfirmDialog({ title, children, confirmLabel, confirm, close }: {
  title: string; children: ReactNode; confirmLabel: string; confirm: () => void; close: () => void;
}) {
  const opener = useRef(document.activeElement);
  const id = 'plan-unifie-confirmation';
  useEffect(() => {
    const element = document.getElementById(id);
    if (!element) return;
    Modal.init();
    const instance = Modal.getInstance(element);
    instance.show();
    return () => { instance.dispose(); if (opener.current instanceof HTMLElement) opener.current.focus(); };
  }, []);
  const hide = () => {
    const element = document.getElementById(id);
    if (element) Modal.getInstance(element)?.hide();
  };
  return <CenterModal title={title} dataTarget={id} onHide={close} onClick={hide}
    className="pu-modal-dialog"
    body={<div className="sp-stack">{children}</div>}
    footer={<div className="sp-row">
      <NJButton label="Annuler" emphasis="subtle" onClick={hide} />
      <NJButton label={confirmLabel} onClick={() => { hide(); confirm(); }} />
    </div>} />;
}
